import keyMirror from 'keymirror'

export const DIR_STATUS = keyMirror({
  // DRAFT is for ADD only
  DRAFT: null,

  /**
   * CART is the status before SUBMITTED (WAPPR) for both ADD and REMOVE
   * staff doesn't have approve permit need to add directory requisition to CART first
   * could be skipped for staff with approve permission
   */
  CART: null,
  SUBMITTED: null,
  // WAPPR is the alias for SUBMITTED, appears on UI only
  WAPPR: null,

  APPR: null,
  REJECTED: null,
  PROCESSED: null,
  PUBLISHED: null,
  REMOVED: null,
})

export const DIR_ACTION = keyMirror({
  ADD: null,
  REMOVE: null,
})

export const DIR_TYPE = keyMirror({
  LOBBY: null,
  FLOOR: null,
})

export const DIR_COMP_TYPE = keyMirror({
  MAIN: null,
  SUB: null,
  DETAIL: null,
})

export const tenantCreatorEditableStatus = [DIR_STATUS.DRAFT, DIR_STATUS.CART, DIR_STATUS.REJECTED]
export const creatorEditableStatus = [DIR_STATUS.DRAFT, DIR_STATUS.CART, DIR_STATUS.REJECTED, DIR_STATUS.SUBMITTED, DIR_STATUS.APPR]
export const hkldCreatorEditableStatus = [DIR_STATUS.DRAFT, DIR_STATUS.CART, DIR_STATUS.SUBMITTED, DIR_STATUS.REJECTED, DIR_STATUS.APPR, DIR_STATUS.PROCESSED]
export const readPermitHolderVisibleStatusMap = {
  [DIR_ACTION.ADD]: [DIR_STATUS.SUBMITTED, DIR_STATUS.APPR, DIR_STATUS.PUBLISHED, DIR_STATUS.PROCESSED, DIR_STATUS.REMOVED],
  [DIR_ACTION.REMOVE]: [DIR_STATUS.CART, DIR_STATUS.REJECTED, DIR_STATUS.SUBMITTED, DIR_STATUS.APPR, DIR_STATUS.PUBLISHED, DIR_STATUS.PROCESSED, DIR_STATUS.REMOVED],
}

export const COLUMN_ON_HOLD = 'On Hold'

export const DIR_LOBBY_DISPLAYS = ['1', '2', '3']
export const DIR_LOBBY_SCREENS = ['1', '2', '3']
export const DIR_DROPDOWN_ALL = 'All'

export const DIR_FLOOR_DISPLAY_TYPES = keyMirror({
  Left: '',
  Right: '',
})

export const DIR_FLOOR_DISPLAYS = [
  DIR_FLOOR_DISPLAY_TYPES.Left,
  DIR_FLOOR_DISPLAY_TYPES.Right,
  'N/A',
]

export const defaultEmptyLobbyGroups = {
  '1': {
    '1': [],
    '2': [],
    '3': [],
  },
  '2': {
    '1': [],
    '2': [],
    '3': [],
  },
  '3': {
    '1': [],
    '2': [],
    '3': [],
  },
  others: [],
}

export const defaultEmptyFloorGroups = {
  'floor': [],
  'others': [],
}

export const MAINTAIN_HISTORY_TYPE = keyMirror({
  PROCESS: null,
  SAVE: null,
  REMOVE_DIRECTORY: null,
})

export const DUPLICATE_DIRECTORY_OFFSET = 0.1
export const DEFAULT_SOURCEID = '0'
